// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../../node_module_clones/recompose';

// Utils
import { resizableEditorContainerStyle } from '../../resizing/resizableEditor/resizableEditorUtils';
import { getElementId, getLinkedElementId } from '../../../../common/elements/utils/elementPropertyUtils';

// Components
import useEditorOverflowObserver from '../../resizing/resizableEditor/useEditorOverflowObserver';
import suggestDocumentDecorator from '../suggestDocumentDecorator';
import suggestDocumentHeightObserver from './suggestDocumentHeightObserver';
import CardEditor from '../CardEditor';
import ResizableEditorOverflowOverlay from '../../resizing/resizableEditor/ResizableEditorOverflowOverlay';
import CardClipper from '../clipper/CardClipper';

// Constants
import { ElementType } from '../../../../common/elements/elementTypes';

// Styles
import './ResizableCardEditorContainer.scss';

// Really 2.5, but the text editor itself adds 9px of padding we need to account for
const CARD_PADDING_GRID_UNITS = 3.4;
const TARGET_EDITOR_KEYS = [ElementType.CARD_TYPE];

const HeightObservedCardEditor = suggestDocumentHeightObserver(CardEditor);

const getOriginalEditorId = ({ element, elementId, isClone }) => {
    const originalElementId = isClone ? getLinkedElementId(element) : elementId;
    return `${originalElementId}-${ElementType.CARD_TYPE}`;
};

const ResizableCardEditorContainer = (props) => {
    const { element, isClone } = props;

    const elementId = getElementId(element);
    const originalEditorId = getOriginalEditorId({ element, elementId, isClone });

    const { editorOverflowed, editorRef, containerRef, isEditingTargetContent } = useEditorOverflowObserver(
        props,
        TARGET_EDITOR_KEYS,
        CARD_PADDING_GRID_UNITS,
    );

    return (
        <div
            className="ResizableCardEditorContainer"
            style={resizableEditorContainerStyle(props, isEditingTargetContent)}
            ref={containerRef}
        >
            <div className="card-editor-container-contents">
                <HeightObservedCardEditor {...props} originalEditorId={originalEditorId} editorRef={editorRef} />
                <ResizableEditorOverflowOverlay show={!props.transparent && editorOverflowed} />
            </div>
            <CardClipper elementId={elementId} {...props} />
        </div>
    );
};

const enhancer = compose(suggestDocumentDecorator);

ResizableCardEditorContainer.propTypes = {
    element: PropTypes.object.isRequired,
    gridSize: PropTypes.number.isRequired,
    tempContainerHeight: PropTypes.number,
    isClone: PropTypes.bool,
    editorOverflowed: PropTypes.bool,
    containerRef: PropTypes.func,
    isEditing: PropTypes.bool,
    transparent: PropTypes.bool,
};

export default enhancer(ResizableCardEditorContainer);
